import { history } from 'instantsearch.js/es/lib/routers'
import { createRoot } from 'react-dom/client'
import App, { type AppProps } from './components/App'
import {
  ConfigProvider,
  type IndexName,
  type WidgetConfig
} from './components/ConfigContext'

function getRouting(indexName: IndexName): AppProps<{
  q?: string
  type?: string
}>['routing'] {
  return {
    router: history({ cleanUrlOnDispose: false }),
    stateMapping: {
      stateToRoute(uiState) {
        return {
          q: uiState[indexName]?.query
          // TODO: Add type to the query string
          // type: uiState.services?.refinementList?.status?.[0]
        }
      },
      routeToState(routeState) {
        return {
          /*
          [indexName]: {
            query: routeState.q
            // refinementList: {
            //   status: [routeState.type].filter(Boolean)
            // }
          }
          */
        }
      }
    }
  }
}

for (const container of document.querySelectorAll<HTMLElement>(
  '[data-services-list-config]'
)) {
  const configJSON = container.dataset.servicesListConfig
  if (!configJSON) {
    console.warn('Missing data-services-list-config attribute')
    continue
  }
  const config = JSON.parse(configJSON) as WidgetConfig
  const routing = getRouting(config.indexName)

  const reactRoot = createRoot(container)
  reactRoot.render(
    <ConfigProvider value={config}>
      <App routing={routing} />
    </ConfigProvider>
  )
}
